import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingCart } from 'lucide-react';
const purchases = [{
  name: 'Lukas M.',
  location: 'München, Deutschland'
}, {
  name: 'Julia W.',
  location: 'Berlin, Deutschland'
}, {
  name: 'Sebastian K.',
  location: 'Hamburg, Deutschland'
}, {
  name: 'Anna B.',
  location: 'Köln, Deutschland'
}, {
  name: 'Tobias R.',
  location: 'Frankfurt, Deutschland'
}, {
  name: 'Laura S.',
  location: 'Stuttgart, Deutschland'
}, {
  name: 'Daniel H.',
  location: 'Düsseldorf, Deutschland'
}, {
  name: 'Sandra P.',
  location: 'Leipzig, Deutschland'
}, {
  name: 'Markus T.',
  location: 'Dresden, Deutschland'
}, {
  name: 'Nina F.',
  location: 'Hannover, Deutschland'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 12000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      {visible && <div className="fixed bottom-4 left-4 right-4 sm:left-4 sm:right-auto z-50 animate-slide-in" data-id="element-177">
          <button onClick={scrollToPricing} className="block w-full sm:w-auto text-left bg-white border-4 border-brand-gold shadow-2xl rounded-xl p-3.5 pr-9 max-w-xs relative ring-2 ring-brand-petrol/20 hover:ring-brand-petrol/40 transition-all cursor-pointer" data-id="element-178">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-brand-petrol via-brand-gold to-brand-petrol rounded-t" data-id="element-179"></div>
            <span onClick={e => {
          e.stopPropagation();
          setVisible(false);
        }} className="absolute top-2 right-2 text-gray-400 hover:text-brand-graphite transition-colors" data-id="element-180">
              <XIcon className="w-4 h-4" data-id="element-181" />
            </span>
            <div className="flex items-start gap-3" data-id="element-182">
              <div className="w-10 h-10 rounded-full bg-brand-gold/20 flex items-center justify-center shrink-0 border-2 border-brand-gold" data-id="element-183">
                <ShoppingCart className="w-5 h-5 text-brand-petrol" data-id="element-184" />
              </div>
              <div data-id="element-185">
                <p className="font-bold text-brand-graphite text-sm leading-tight" data-id="element-186">
                  {currentPurchase.name}
                </p>
                <p className="text-xs text-gray-600 mt-0.5" data-id="element-187">
                  {currentPurchase.location}
                </p>
                <p className="text-xs text-brand-petrol font-semibold mt-1" data-id="element-188">
                  hat gerade das System gekauft 🔥
                </p>
              </div>
            </div>
          </button>
        </div>}
    </>;
}